import React from "react";
import { useCliente } from "../../context/ClienteContext";

/** Cabecera común de módulos operativos. */
export default function ModuleHeader({ eyebrow, title, description, actions, children, clientDetails = false, className = "" }) {
  const context = useCliente();
  const client = clientDetails ? context?.clienteInfo : null;
  const contact = [client?.telefono, client?.email].filter(Boolean).join(" · ");
  return (
    <header className={`card mp-module-header ${className}`.trim()}>
      <div className="mp-module-header-copy">
        {eyebrow ? <div className="mp-module-eyebrow">{eyebrow}</div> : null}
        <h1>{title}</h1>
        {description ? <p>{description}</p> : null}
      </div>
      {client?.id ? <aside className="mp-client-header-summary" aria-label="Datos del cliente seleccionado">
        <strong>{client.codigo_cliente ? client.codigo_cliente + " · " : ""}{client.nombre || "Cliente seleccionado"}</strong>
        <span>{contact || "Sin teléfono ni correo registrados"}</span>
        <small title={client.observaciones || ""}>{client.observaciones || "Sin observaciones"}</small>
      </aside> : (children ? <div className="mp-module-header-context">{children}</div> : null)}
      {actions ? <div className="mp-module-header-actions">{actions}</div> : null}
    </header>
  );
}
